import dynamic from 'next/dynamic'

export const ReduxProvider = dynamic(() => import('./ReduxProvider'))
export const ThemeProvider = dynamic(() => import('./ThemeProvider'))
export const I18nProvider = dynamic(() => import('./I18nProvider'))
